const PaymentMethod = {
    /**
     * Desconto em folha de pagamento
     */
    PayrollDeduction: 1,

    /**
     * Cartão de crédito
     */
    CreditCard: 2,

    /**
     * Boleto
     */
    Ticket: 3,

    /**
     * Débito em conta
     */
    AccountDebit: 4,

    /**
     * Resgate de pontos
     */
    RedeemRewards: 5,

    /**
     * Pix
     */
    Pix: 6,

    /**
     * Doação direta (lançada pela API/operador, sem gateway)
     */
    DirectDonation: 7,

    /**
     * Maquininha de cartão (presencial)
     */
    CartMachine: 8,

    /**
     * Pix Automático
     */
    PixAutomatic: 9
};

export default PaymentMethod;